// src/state/settings.ts — local-only persistence (grounding: no Firestore in this build).
// Settings and the BYOK key live in localStorage; treat the key as a device-local secret.
import type { Settings } from "../core/models";

const KEY_STORE = "llabaro_key";
const SETTINGS_STORE = "llabaro_settings";

export const defaultSettings: Settings = {
  pair: { native: "en", foreign: "de" },
  liveMode: "interpret",
  listenEnabled: true,
  ttsEnabled: false,
  autoSpeak: true,
  volume: 0.8,
  voice: "Kore",
  textScale: 1.6,
  chunkMs: 20,
  echoTargetLanguage: false,
};

export const loadKey = (): string => {
  try {
    return localStorage.getItem(KEY_STORE) ?? "";
  } catch {
    return "";
  }
};

export const saveKey = (k: string): void => {
  try {
    localStorage.setItem(KEY_STORE, k);
  } catch {
    /* device-local storage may be unavailable; degrade silently */
  }
};

export const clearKey = (): void => {
  try {
    localStorage.removeItem(KEY_STORE);
  } catch {
    /* ignore */
  }
};

export const loadSettings = (): Settings => {
  try {
    return { ...defaultSettings, ...JSON.parse(localStorage.getItem(SETTINGS_STORE) ?? "{}") };
  } catch {
    return defaultSettings;
  }
};

export const saveSettings = (s: Settings): void => {
  try {
    localStorage.setItem(SETTINGS_STORE, JSON.stringify(s));
  } catch {
    /* ignore */
  }
};
